import { Controller } from "@hotwired/stimulus";

// Pflicht-Auswahlfeld mit eigenem Hinweistext: verhindert das Absenden, solange nichts ausgewählt ist
// (z. B. Dokument-Kategorie beim Upload im Backend), und zeigt den Hinweis zusätzlich unter dem Feld an.
export default class extends Controller {
  static targets = ["select", "error"]
  static values = { message: String }

  invalid() {
    this.selectTarget.setCustomValidity(this.messageValue)
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = this.messageValue
      this.errorTarget.classList.remove('hidden')
    }
    this.selectTarget.classList.add('border-red-500')
  }

  change() {
    this.selectTarget.setCustomValidity('')
    if (this.hasErrorTarget) this.errorTarget.classList.add('hidden')
    this.selectTarget.classList.remove('border-red-500')
  }
}
